import { getContext } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { openFipMigrationModal, ModalType } from '@fiverr-private/pro_migration';
import { TryHourlyRatesProps } from './types';

export const showMigrationModal = ({
    source,
    migrationBiEnrichment,
    onMigrationSuccess,
}: Pick<TryHourlyRatesProps, 'source' | 'migrationBiEnrichment' | 'onMigrationSuccess'>) =>
    openFipMigrationModal({
        variant: ModalType.SeamlessHourly,
        payload: {
            source,
            biEnrichment: { ...migrationBiEnrichment },
            onSuccess: onMigrationSuccess,
        },
    });

export const redirectToSignUpPage = ({ registrationSource }: Pick<TryHourlyRatesProps, 'registrationSource'>) => {
    const registrationUrl = pathfinder(
        'identification_business_registration_page',
        {},
        {
            query: { source: registrationSource, session_type: 'sign_up' },
        }
    );

    window.open(registrationUrl);
};

type CtaClickParams = Parameters<typeof showMigrationModal>[0] & Parameters<typeof redirectToSignUpPage>[0];

export const onCtaButtonClick = ({
    source,
    migrationBiEnrichment,
    registrationSource,
    onMigrationSuccess,
}: CtaClickParams) => {
    const { userId } = getContext();
    if (userId) {
        showMigrationModal({ source, migrationBiEnrichment, onMigrationSuccess });
    } else {
        redirectToSignUpPage({ registrationSource });
    }
};

export const onMigrationSuccessDefault = () => {
    window.location.reload();
};
